import * as React from "react";
import PropTypes from "prop-types";
import { MemoryRouter, Route } from "react-router-dom";
import Raven from "raven-js";
import RootRoutes from "nexia_mobile/components/Routing/RootRoutes";
import ErrorPage from "nexia_mobile/components/Pages/ErrorPage";
import ErrorHandler from "nexia_mobile/components/ErrorHandler";
import Toaster from "nexia_mobile/components/Toaster";
import GlobalBlockingSpinner from "nexia_mobile/components/GlobalBlockingSpinner";
import DarkModeInverter from "nexia_mobile/components/DarkModeInverter";
import { setHistory } from "nexia_mobile/history";
import { LanguageContextWrapper } from "nx-components/ContextWrappers/LanguageContext";

export default class App extends React.Component {
  static propTypes = {
    // These are only used by storybook stories for generating app store images.
    initialEntries: PropTypes.arrayOf(
      PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object, // Location object
      ])
    ),
    initialIndex: PropTypes.number,
  };

  render() {
    const { initialEntries, initialIndex } = this.props;

    return (
      <LanguageContextWrapper>
        <ErrorHandler fallback={<ErrorPage />}>
          <MemoryRouter
            initialEntries={initialEntries}
            initialIndex={initialIndex}
          >
            <React.Fragment>
              <Route
              // No path; always render
              >
                {({ history, location }) => {
                  setHistory(history);

                  Raven.captureBreadcrumb({
                    category: "Route changed",
                    level: "info",
                    message: location.pathname,
                  });

                  return (
                    <React.Fragment>
                      {/* This div is for end-to-end testing. */}
                      <div
                        style={{ display: "none" }}
                        id="current-route"
                        data-pathname={location.pathname}
                      />
                      <DarkModeInverter>
                        {({ maybeInvert }) => {
                          Object.assign(document.body.style, maybeInvert);
                          return null;
                        }}
                      </DarkModeInverter>
                      <RootRoutes />
                    </React.Fragment>
                  );
                }}
              </Route>
              <Toaster />
              <GlobalBlockingSpinner />
            </React.Fragment>
          </MemoryRouter>
        </ErrorHandler>
      </LanguageContextWrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App.jsx